import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=ae714c0e&scoped=true&"
import script from "./SetPassword.vue?vue&type=script&lang=ts&"
export * from "./SetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=ae714c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae714c0e",
  null
  
)

export default component.exports